import React, { useEffect, useState } from "react";
import app from "nystem";

const TextExtractionActivity = ({ view }) => {
  const [result, setResult] = useState(view.value || {});
  const [now, setNow] = useState(Date.now());
  const [error, setError] = useState("");
  const id = view.value?._id;
  useEffect(() => {
    let active = true;
    let timer;
    setResult(view.value || {});
    const refresh = async () => {
      let finished = false;
      try {
        const response = await app.database.result.get({ id });
        if (!active) return;
        if (response.error) throw new Error(response.error.message || String(response.error));
        if (response.data?._id) setResult(response.data);
        finished = ["complete", "failed"].includes(response.data?.status);
        setNow(Date.now());
        setError("");
      } catch {
        if (active) setError("Could not refresh activity. Reconnecting…");
      } finally {
        if (active && !finished) timer = setTimeout(refresh, 3000);
      }
    };
    if (id) refresh();
    return () => { active = false; clearTimeout(timer); };
  }, [id]);
  const running = ["queued", "extracting"].includes(result.status);
  const elapsed = result.startedAt ? Math.max(0, Math.floor((now - Date.parse(result.startedAt)) / 1000)) : null;
  return (
    <section className="my-3 rounded-lg border border-gray-200 bg-gray-50 p-4" aria-label="Extraction activity">
      <div className="flex flex-wrap items-center gap-3">
        <strong>Extraction activity</strong>
        <span>{result.status || "Waiting"}</span>
        {running && elapsed !== null && <span className="text-sm text-gray-500">{Math.floor(elapsed / 60)}m {elapsed % 60}s elapsed</span>}
      </div>
      <p className="mt-2" role="status">{result.activityMessage || (running ? "Waiting for extraction updates. This run started before activity logging was available." : "No activity recorded.")}</p>
      {running && <p className="mt-1 text-sm text-gray-500">Processing progress is stage based. Reading the document may take several minutes without a new event.</p>}
      {result.error && <p className="mt-2 text-red-700">{result.error}</p>}
      {error && <p className="mt-2 text-amber-700">{error}</p>}
      {result.activityLog && <details className="mt-3" open>
        <summary className="cursor-pointer text-sm font-semibold">Activity history</summary>
        <pre className="mt-2 max-h-80 overflow-auto whitespace-pre-wrap break-words text-xs">{result.activityLog}</pre>
      </details>}
    </section>
  );
};
export default TextExtractionActivity;
